import React from 'react';
import CreateSession from 'containers/CreateSession';
import StagingEnvironmentArticle from 'components/organisms/StagingEnvironmentArticle';

export default () => (
  <CreateSession target='staging'>
    <StagingEnvironmentArticle/>
  </CreateSession>
);
